export var H265 = 'H265';
var H265_CAPABILITY = { vcodec: H265 };
export function filterOutProtected(capabilities) {
    var unprotectedCapabilities = [];
    for (var i = 0, length_1 = capabilities.length; i < length_1; i++) {
        if (capabilities[i].protection === 'NONE') {
            unprotectedCapabilities.push(capabilities[i]);
        }
    }
    return unprotectedCapabilities;
}
/**
 * @param capabilities - An array of playback capabilities
 * @returns capabilities - A new array with duplicated capabilities for `H265`
 */
export function addH265DeviceCapabilities(capabilities) {
    var deviceCapabilities = [];
    for (var i = 0, length_2 = capabilities.length; i < length_2; i++) {
        deviceCapabilities.push(Object.assign({}, capabilities[i], H265_CAPABILITY), capabilities[i]);
    }
    return deviceCapabilities;
}
//# sourceMappingURL=video-device-capabilities-utils.js.map